export default __webpack_public_path__ + "static/media/talent-clue-logo.48cc28b9.png";